import React, { useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ShopContext } from './shopinfo';
import { useShop } from "./shopinfo";

const PgidRedirect = () => {
    const { shopData, setShopData } = useContext(ShopContext);
    const navigate = useNavigate();
    const { pgid } = useParams();

    useEffect(() => {
        console.log("Current PGID:", pgid);
        
        // Always fetch new data when PGID changes
        fetch(`/api-shopinfo/${pgid}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    console.log("Updating PGID to:", pgid);
                    localStorage.setItem("pgid", pgid); //  Store the new PGID
                    setShopData(data.data); //  Update shop data
                    navigate("/"); //  Redirect to main page
                } else {
                    console.error("Shop data fetch failed:", data.message);
                    navigate("/error"); // Handle errors
                }
            })
            .catch(error => console.error("Fetch error:", error));

    }, [pgid, navigate, setShopData]); //  Make sure effect runs when PGID changes

    return <p>Loading shop info...</p>;
};

export default PgidRedirect;